import "./CustomForm.css";
import React from "react";
import MessageContainer from "shared/components/message/MobxMessageContainer";
import isEmpty from "lodash/isEmpty";
import map from "lodash/map";
import { observer } from "mobx-react";
import ContentItem from "shared/components/cms/ContentItem";

@observer
class FormError extends React.Component {

    _convertToErrorMessage(error, index) {
        let errorMessage = "";
        if (error.errorMessageCmsKey) {
            errorMessage = <ContentItem contentKey={error.errorMessageCmsKey} />;
        } else if (error.errorMessageText) {
            errorMessage = <span>{error.errorMessageText}</span>;
        } else {
            errorMessage = <span>{error}</span>;
        }
        return {
            message: errorMessage,
            className: "error",
            id: `form-level-error-${index}`,
            icon: "attention",
            closeable: false
        };
    }

    _getFormLevelErrorMessages() {
        let messages = [];
        if (this.props.form.hasErrors) {
            let errorMessages = map(this.props.form.errors.get("form-level-error"), (error, index) => this._convertToErrorMessage(error, index));
            if (isEmpty(errorMessages)) {
                errorMessages = [this._convertToErrorMessage("Please fix all errors below.")];
            }
            messages = messages.concat(errorMessages);
        }
        return messages;
    }

    render() {
        return (
            <MessageContainer containerId={this.props.form.messageContainerId} type="message" messages={this._getFormLevelErrorMessages()} />
        );
    }
}

export default FormError;
